import React from 'react';
import { Credits } from '../styles';
import { FaFacebook, FaInstagram, FaGithub, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { IoIosArrowUp } from "react-icons/io";

const Footer = () => {

    const handleClick = () => {
        window.scroll(0, 0);
    }

    return ( 
        <Credits>
            <span>
                <i onClick={handleClick}><IoIosArrowUp /></i>
            </span>
            <div>
                <ul>
                   <li><a rel="noopener noreferrer" href="https://github.com/ezelujan" target="_blank"><FaGithub /></a></li>
                   <li><a rel="noopener noreferrer" href="https://www.linkedin.com/in/ezedev/" target="_blank"><FaLinkedinIn /></a></li>
                   <li><a rel="noopener noreferrer" href="https://www.facebook.com/ezelujan147/" target="_blank"><FaFacebook /></a></li> 
                   <li><a rel="noopener noreferrer" href="https://www.instagram.com/ezequiel_147/" target="_blank"><FaInstagram /></a></li> 
                   <li><a rel="noopener noreferrer" href="https://twitter.com/EzequielLujnEs1" target="_blank"><FaTwitter /></a></li> 
                </ul>
            </div>
            <div>
                <p>&copy; 2020 - developed by <a rel="noopener noreferrer" target="_blank" href="https://github.com/ezelujan">Ezequiel Luján</a></p>
            </div>
        </Credits>
    );
}
 
export default Footer;